<template>
  <div
    class="favourite-partner"
  >
    <div class="favourite-partner-container">
      <p class="user-profile-text">
        Twój Partner Serwisowy
      </p>
      <div class="favourite-partner-wrapper">
        <service-station-block
          class="card-block"
          :service-station="partner"
          :with-slot="true"
          :show-image="true"
          :show-details="true"
          :set-favourite="true"
          v-if="partner !== null"
        >
          <standard-button
            custom-class="change-button fluid"
            :background-color="thirdColor"
            @buttonClick="openModal"
            classType="secondary"
            text="Zmień Partnera Serwisowego"
          />
        </service-station-block>
        <add-partner v-else />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StandardButton from '~/StandardButton';
import ServiceStationBlock from '~/ServiceStationBlock';
import AddPartner from '~/AddPartner';

export default {
  components: {
    StandardButton,
    ServiceStationBlock,
    AddPartner,
  },
  computed: {
    ...mapGetters({
      partner: 'user/getFavouritePartner',
      thirdColor: 'brand/getThirdColor',
      fonts: 'brand/getFonts',
    }),
  },
  methods: {
    ...mapActions({
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      setModalStep: 'modal/setModalStep',
    }),
    openModal() {
      this.setModalContent({
        changeFavourite: true,
      });
      this.setModalStep('change_partner');
      this.toggleModal();
    },
  },
};
</script>
